import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { marginSizes, borderRadius, borderRadiusSizes } from 'theme/default'
import Component from 'decorators/Component'
import Flex from 'components/Flex'
import { P } from 'components/Typo'
import Image from 'components/Image'

export const OrderItemContainer = styled(Flex).attrs((props) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'stretch'
}))``

export const OrderItemImage = styled(Image).attrs((props) => ({
  width: 80,
  height: 80,
  objectFit: 'cover'
}))`
  border-radius: ${borderRadius[borderRadiusSizes.medium]};
`

export const OrderItemDetails = styled(Flex).attrs((props) => ({
  flexDirection: 'column',
  justifyContent: 'flex-between',
  alignItems: 'stretch',
  alignContent: 'flex-start'
}))`
  width: 100%;
`

const MainContainer = styled(Flex).attrs((props) => ({
  flexDirection: 'row',
  flex: '1 1 auto'
}))``

const QuantityContainer = styled(Flex).attrs((props) => ({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  flex: 'flex: 0 0 120px',
  marginLeft: marginSizes.medium
}))`
  text-align: right;
`

export const PromotionalOrderItem = Component()(({ t, item = {}, formatMoney = x => x }) => {
  return (
    <OrderItemContainer>
      <MainContainer><P normalised align='left'>{`${item.quantity}x ${item.name}`}</P></MainContainer>
      <QuantityContainer>
        <P normalised align='right'>{item.price ? formatMoney(item.quantity * item.price) : t('FREE')}</P>
      </QuantityContainer>
    </OrderItemContainer>
  )
})

PromotionalOrderItem.propTypes = {
  item: PropTypes.object,
  formatMoney: PropTypes.func
}

export const OrderItem = ({
  item = {},
  formatMoney = x => x,
  showImage = true,
  imageSrc = null,
  choicesParser = (item) => item.subitemChoices
}) => {
  return (
    <OrderItemContainer>
      <MainContainer>
        {showImage && imageSrc && (
          <Flex flexDirection='column' justifyContent='flex-start' marginRight={marginSizes.small}>
            <OrderItemImage src={imageSrc} />
          </Flex>)}
        <OrderItemDetails>
          <P bold normalised>{`${item.quantity}x ${item.name}`}</P>
          {(choicesParser(item) || []).map((c) => (
            <P normalised key={c.id}>{`${c.quantity}x ${c.name}`}</P>
          ))}
        </OrderItemDetails>
      </MainContainer>
      <QuantityContainer>
        <P normalised>{formatMoney(item.quantity * item.price)}</P>
      </QuantityContainer>
    </OrderItemContainer>
  )
}

OrderItem.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    quantity: PropTypes.number,
    price: PropTypes.number,
    subitemChoices: PropTypes.array,
    imageUrl: PropTypes.string
  }),
  formatMoney: PropTypes.func,
  choicesParser: PropTypes.func,
  showImage: PropTypes.bool,
  imageSrc: PropTypes.string
}

export default OrderItem
